import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

/* eslint-disable @typescript-eslint/naming-convention */
// We want these to match the API schema as closely as possible

export const cortexJsonSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    guardrails: {
      type: 'object',
      description: 'Controls whether Cortex Guard guardrails are used for the request.',
      properties: {
        enabled: {
          type: 'boolean',
          description:
            'Controls whether guardrails are used for the request. If not present or not true, guardrails are not used.',
        },
        response_when_unsafe: {
          type: 'string',
          description:
            'Determines the response when the Cortex Guard model deems the response unsafe. This string, not the actual completion, is returned in the output.',
          default: 'Response filtered by Cortex Guard',
        },
      },
      default: null,
    },
    max_tokens: {
      type: 'integer',
      description:
        'A value between 1 and 4096 (inclusive) that controls the maximum number of tokens to output. Output is truncated after this number of tokens.',
      minimum: 1,
      maximum: 4096,
      default: 4096,
    },
    top_p: {
      type: 'number',
      description:
        'A value from 0 to 1 (inclusive) that controls the diversity of the language model by restricting the set of possible tokens that the model outputs.',
      minimum: 0,
      maximum: 1,
      default: 1.0,
    },
    temperature: {
      type: 'number',
      description:
        'A value from 0 to 1 (inclusive) that controls the randomness of the output of the language model by influencing which possible token is chosen at each step.',
      minimum: 0,
      maximum: 1,
      default: 0.0,
    },
  },
  additionalProperties: false,
} as const;

// this confirms that the type is a valid JSON schema, but we want it as a `const` so we can use it to index the properties
export const cortexSchemaProperties: DeepReadonly<JSONSchema7> = cortexJsonSchema;

export const retrieveCortexParameters = (): string[] => Object.keys(cortexJsonSchema.properties);
